<template>
  <Loading v-if="!eodReportRule" />
  <div v-else>
    <h3>Manage End of day reports for {{ activeCountry.name }}</h3>
    <div class="mb-4">
      <small>
        Last updated at
        {{ eodReportRule.updatedAction.timestamp | formatDate }} by
        {{ eodReportRule.updatedAction.userDisplayName }}
      </small>
    </div>
    <div>
      <div class="grid grid-cols-3 max-w-lg gap-6">
        <div>
          <div><b>EOD Submission delay</b></div>
          <small>Specify the time-delay the system must wait before sending a submitted EOD.</small>
        </div>

        <div class="col-span-2">
          <ul class="leftx mb-4">
            <li>
              <vs-radio v-model="eodReportRule.timeDelayType" vs-name="delayType" :vs-value="1">Time delay</vs-radio>
            </li>
            <li>
              <vs-radio v-model="eodReportRule.timeDelayType" vs-name="delayType" :vs-value="2">At specific
                time</vs-radio>
            </li>
          </ul>

          <div v-if="eodReportRule.timeDelayType == 1">
            <vs-slider v-model="eodReportRule.relativeTimeDelay" :max="1440" :step="15" text-fixed="Minutes" />
            <span class="flex gap-1 items-center font-bold" v-if="eodReportRule.relativeTimeDelay > 0">
              <span> Wait </span>
              <vs-chip color="primary">{{ parsedRelativeTimeDelay }}</vs-chip>
              <span> before sending </span>
            </span>
            <vs-chip color="primary" v-else>Send instantly</vs-chip>
          </div>
          <div v-else-if="eodReportRule.timeDelayType == 2">
            <vs-input v-model="eodReportRule.absoluteTimeDelay" type="time" class="mb-2" />
            <span class="flex gap-1 items-center font-bold">
              <span> Send the following day at </span>
              <vs-chip color="primary">{{ eodReportRule.absoluteTimeDelay }}</vs-chip>
              <span> (UTC time zone) </span>
            </span>
            <small>NB: Will send instantly if submitted after this time</small>
          </div>
        </div>

        <div>
          <div><b>EOD</b> recipients</div>
          <small>Recipients roles that receive a copy of the EOD by email</small>
        </div>

        <div class="col-span-2">
          <vs-select multiple autocomplete v-model="eodReportRule.recipientRoles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>

        <!-- <div>
          <div><b>Needs</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select
            v-for="(rule, index) in eodReportRule.needsRatingRules"
            :key="index"
            :label="rule.label"
            multiple
            autocomplete
            v-model="rule.roles"
            class="w-full"
          >
            <vs-select-item
              :key="idx"
              :value="role.id"
              :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles"
            />
          </vs-select>
        </div> -->

        <div>
          <div><b>Incidents</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select v-for="(rule, index) in eodReportRule.incidentsRatingRules" :key="index" :label="rule.label" multiple
            autocomplete v-model="rule.roles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>

        <div>
          <div><b>Security</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select v-for="(rule, index) in eodReportRule.securityRatingRules" :key="index" :label="rule.label" multiple
            autocomplete v-model="rule.roles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>

        <div>
          <div><b>Clientele</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select v-for="(rule, index) in eodReportRule.clienteleRatingRules" :key="index" :label="rule.label" multiple
            autocomplete v-model="rule.roles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>

        <div>
          <div><b>Music</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select v-for="(rule, index) in eodReportRule.musicRatingRules" :key="index" :label="rule.label" multiple
            autocomplete v-model="rule.roles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>

        <div>
          <div><b>NightPay</b> recipients</div>
          <small>Notification rules based on rating</small>
        </div>

        <div class="col-span-2">
          <vs-select v-for="(rule, index) in eodReportRule.nightpayRatingRules" :key="index" :label="rule.label" multiple
            autocomplete v-model="rule.roles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>
      </div>
      <div>
        <vs-button @click="onClickUpdate">Update</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import parseDelay from "parse-duration";
import humanizeDuration from "humanize-duration";

export default {
  data() {
    return {
      eodReportRule: null
    };
  },
  computed: {
    ...mapGetters({
      roles: "roles",
      activeCountry: "venues/activeCountry"
    }),
    parsedRelativeTimeDelay() {
      return humanizeDuration(parseDelay(`${this.eodReportRule.relativeTimeDelay}m`));
    }
  },
  methods: {
    async onClickUpdate() {
      try {
        var relativeTimeHours = Math.floor(this.eodReportRule.relativeTimeDelay / 60);
        var relativeTimeMinutes = this.eodReportRule.relativeTimeDelay % 60;

        if (relativeTimeHours.toString().length == 1) relativeTimeHours = "0" + relativeTimeHours;
        if (relativeTimeMinutes.toString().length == 1) relativeTimeMinutes = "0" + relativeTimeMinutes;

        var modified = {
          ...this.eodReportRule,
          relativeTimeDelay: `${relativeTimeHours}:${relativeTimeMinutes}:00`,
          absoluteTimeDelay: `${this.eodReportRule.absoluteTimeDelay}:00`
        };
        await this.$store.dispatch("eodReportRules/updateEodReportRule", modified);
        this.$vs.notify({
          title: "Success",
          text: "EOD report rule updated",
          color: "success",
          position: "top-right"
        });
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: "EOD report rule could not be updated",
          color: "danger",
          position: "top-right"
        });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("getRoles");
    this.eodReportRuleRaw = await this.$store.dispatch("eodReportRules/getEodReportRule", this.activeCountry.id);

    var relativeTimeDelay = this.eodReportRuleRaw.relativeTimeDelay.split(":");
    var relativeTimeDelayMinutes = parseInt(relativeTimeDelay[0]) * 60 + parseInt(relativeTimeDelay[1]);
    this.eodReportRule = {
      ...this.eodReportRuleRaw,
      relativeTimeDelay: relativeTimeDelayMinutes,
      absoluteTimeDelay: this.eodReportRuleRaw.absoluteTimeDelay.split(":").slice(0, 2).join(":")
    };

    console.log("Rule is now", this.eodReportRule);
  }
};
</script>
